import { ExamStore } from "@hospital/views/exam";
import { ExamLockedStatus } from "@common/models/Enums";

export const useExamNotesAreAllowed = (examStore: ExamStore) => {
    const editableExamNotes = examStore.visitLockStatus === ExamLockedStatus.ExamNotesAreAllowed;
    return editableExamNotes;
}
